module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "search-input",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('label', {
    staticClass: "icon icon-search",
    attrs: {
      "for": "result-gene"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "open-popup open-goods",
    attrs: {
      "data-popup": ".popup-gene-only",
      "type": "search",
      "id": "result-gene",
      "placeholder": "查询基因...",
      "readonly": "",
      "unselectable": "on"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "buttons-row"
  }, [_c('a', {
    staticClass: "tab-link button active",
    attrs: {
      "href": "#tab-detail"
    }
  }, [_vm._v("Detail")]), _vm._v(" "), _c('a', {
    staticClass: "tab-link button",
    attrs: {
      "href": "#tab-comments"
    }
  }, [_vm._v("Comments(123)")])]), _vm._v(" "), _c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tab active",
    attrs: {
      "id": "tab-detail"
    }
  }, [_c('h3', [_vm._v("真正")]), _vm._v(" "), _c('p', [_vm._v("只有当你接触到床的那一刻，才会被前所未有的柔软打动。天丝般的爽滑质感，完美的设计，漂亮的色彩搭配。")]), _vm._v(" "), _c('p', [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "//img.alicdn.com/imgextra/i4/238126515/TB25x8rdXXXXXaWXXXXXXXXXXXX_!!238126515.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('h3', [_vm._v("活性色彩，我的正能量")]), _vm._v(" "), _c('p', [_vm._v("活性印刷，生活不在一成不变，跟上时代的脚步。A版大花纹，古典大气，民族的就是最美。零压力的舒适感，让人完美享受美好的床上时光。")]), _vm._v(" "), _c('p', [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "//img.alicdn.com/imgextra/i3/238126515/TB2ht8qdXXXXXbmXXXXXXXXXXXX_!!238126515.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab-comments"
    }
  }, [_c('div', {
    staticClass: "list-block media-list"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-media"
  }, [_c('img', {
    attrs: {
      "src": "http://gqianniu.alicdn.com/bao/uploaded/i4//tfscom/i3/TB10LfcHFXXXXXKXpXXXXXXXXXX_!!0-item_pic.jpg_250x250q60.jpg",
      "width": "44"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title-row"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("张**三")]), _vm._v(" "), _c('div', {
    staticClass: "item-after"
  }, [_vm._v("12/12 13:11")])]), _vm._v(" "), _c('div', {
    staticClass: "item-text"
  }, [_vm._v("聚划算买的，只要888，料子很舒服。")])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24dfddb0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/DataMeta/DataMeta.vue
// module id = 1570
// module chunks = 8